import SearchBar from "./components/SearchBar"
import StatsDisplay from "./components/StatsDisplay"
import Footer from "./components/Footer"
import TeamContext, {TeamStatsProvider} from "./context/TeamContext"
import { useState, useContext, useEffect  } from "react"


function App() {

    return (
        <TeamStatsProvider>
            <div className="flex flex-col justify-between h-screen">
                <SearchBar />
                <StatsDisplay />
                <Footer />
            </div>
        </TeamStatsProvider>
    )
}

export default App